(function () {
  if (window.AxiomDiscoveryDrawerController) {
    window.AxiomDiscoveryDrawerController.sync();
    return;
  }

  var TRIGGER_SELECTOR = '[data-discovery-drawer-trigger]';
  var DRAWER_SELECTOR = 'discovery-drawer[data-has-content="true"]';

  function getOverlay() {
    return document.getElementById('site-overlay');
  }

  function getActiveDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function syncTriggers(drawer) {
    var hasDrawer = Boolean(drawer && drawer.dataset.hasContent === 'true');
    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function (trigger) {
      trigger.hidden = !hasDrawer;
      if (!hasDrawer) {
        trigger.removeAttribute('aria-controls');
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      trigger.setAttribute('aria-controls', drawer.id);
      trigger.setAttribute('aria-expanded', drawer.getAttribute('aria-hidden') === 'false' ? 'true' : 'false');
    });
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        if (!document.execCommand('copy')) throw new Error('Copy failed');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  if (!customElements.get('discovery-drawer')) {
    customElements.define('discovery-drawer', class DiscoveryDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.discoveryInitialized === 'true') return;
        this.dataset.discoveryInitialized = 'true';
        this.overlay = getOverlay();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('theme:drawer:open', this.handleDrawerOpen);
        this._activePanel = Array.from(this.querySelectorAll('[data-discovery-panel]')).find(function (panel) { return !panel.hidden; }) || null;
        this._tabAnimations = [];
        this._tabTransitionId = 0;
        syncTriggers(this);

        // Shopify marks every customer form on the page as posted, so open only when the redirect
        // hash names this drawer's own newsletter form, on the tab that holds it.
        var postedSuccess = this.getPostedNewsletterSuccess();
        if (postedSuccess) {
          this.showPanelOf(postedSuccess);
          this.open(document.querySelector(TRIGGER_SELECTOR));
        }
      }

      getPostedNewsletterSuccess() {
        var hash = window.location.hash ? window.location.hash.slice(1) : '';
        if (!hash) return null;
        try { hash = decodeURIComponent(hash); } catch (error) { return null; }
        return Array.from(this.querySelectorAll('[data-discovery-newsletter-success]')).find(function (message) {
          var form = message.closest('form');
          return Boolean(form && form.id === hash);
        }) || null;
      }

      showPanelOf(element) {
        var panel = element.closest('[data-discovery-panel]');
        if (!panel || !panel.hidden || panel.classList.contains('discovery-drawer__tabpanel--disabled')) return;
        var group = panel.dataset.discoveryPanel;
        this.querySelectorAll('[data-discovery-tab]').forEach(function (tab) {
          var active = tab.dataset.discoveryTab === group;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.settleTabPanels(panel);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('theme:drawer:open', this.handleDrawerOpen);
        this.cancelTabTransition();
        this.dataset.discoveryInitialized = 'false';
        window.requestAnimationFrame(function () { syncTriggers(getActiveDrawer()); });
      }

      // options.preview: opened by the theme editor (no focus taken from it, no scroll lock).
      open(trigger, options) {
        var preview = Boolean(options && options.preview);
        var canPreviewEmpty = Boolean(window.Shopify && window.Shopify.designMode);
        if ((this.dataset.hasContent !== 'true' && !canPreviewEmpty) || !window.Axiom || typeof window.Axiom.openDrawer !== 'function') return;
        this.overlay = getOverlay();
        if (this.overlay) {
          this.overlay.classList.add('overlay--discovery-active');
          this.overlay.style.setProperty('--discovery-overlay-scrim', getComputedStyle(this).getPropertyValue('--discovery-overlay-scrim'));
        }
        window.Axiom.openDrawer(this, this.overlay, {
          autofocus: preview ? false : undefined,
          lockScroll: !preview,
          returnFocus: preview ? null : (trigger || document.activeElement),
          focusTarget: this.querySelector('.discovery-drawer__title'),
          trapFocus: true
        });
        syncTriggers(this);
      }

      close(options) {
        options = options || {};
        if (!window.Axiom || typeof window.Axiom.closeDrawer !== 'function') return;
        if (options.handoff) delete this._drawerReturnFocus;
        window.Axiom.closeDrawer(this, options.keepOverlay ? null : this.overlay);
        if (this.overlay) {
          this.overlay.classList.remove('overlay--discovery-active');
          this.overlay.style.removeProperty('--discovery-overlay-scrim');
        }
        syncTriggers(this);
      }

      switchTab(group, focusTab) {
        var tabs = Array.from(this.querySelectorAll('[data-discovery-tab]'));
        var panels = Array.from(this.querySelectorAll('[data-discovery-panel]'));
        var targetTab = tabs.find(function (tab) { return tab.dataset.discoveryTab === group; });
        var targetPanel = panels.find(function (panel) { return panel.dataset.discoveryPanel === group; });
        if (!targetPanel) return;

        this.cancelTabTransition();
        var currentPanel = this._activePanel && panels.includes(this._activePanel)
          ? this._activePanel
          : panels.find(function (panel) { return !panel.hidden; });

        tabs.forEach(function (tab) {
          var active = tab === targetTab;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        if (focusTab && targetTab) targetTab.focus();

        var reducedMotion = window.Axiom && typeof window.Axiom.prefersReducedMotion === 'function'
          ? window.Axiom.prefersReducedMotion()
          : window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (currentPanel === targetPanel || !currentPanel || reducedMotion || typeof targetPanel.animate !== 'function') {
          this.settleTabPanels(targetPanel, { resetScroll: currentPanel !== targetPanel });
          return;
        }

        var currentIndex = panels.indexOf(currentPanel);
        var targetIndex = panels.indexOf(targetPanel);
        var direction = targetIndex >= currentIndex ? 1 : -1;
        var transitionId = ++this._tabTransitionId;
        var duration = window.Axiom && typeof window.Axiom.getMotionDuration === 'function'
          ? window.Axiom.getMotionDuration('--motion-duration-fast', '220ms')
          : 220;
        var easing = window.Axiom && typeof window.Axiom.getMotionEase === 'function'
          ? window.Axiom.getMotionEase('--motion-ease-soft', 'cubic-bezier(0.33, 1, 0.68, 1)')
          : 'cubic-bezier(0.33, 1, 0.68, 1)';
        var timing = { duration: duration, easing: easing, fill: 'both' };

        panels.forEach(function (panel) {
          if (panel !== currentPanel && panel !== targetPanel) {
            panel.hidden = true;
            panel.classList.remove('is-leaving', 'is-entering');
          }
          panel.toggleAttribute('inert', panel !== targetPanel);
        });
        currentPanel.classList.add('is-leaving');
        currentPanel.classList.remove('is-entering');
        targetPanel.classList.add('is-entering');
        targetPanel.classList.remove('is-leaving');
        targetPanel.hidden = false;
        targetPanel.scrollTop = 0;
        this._activePanel = targetPanel;

        this._tabAnimations = [
          currentPanel.animate([
            { opacity: 1, transform: 'translateX(0)' },
            { opacity: 0, transform: 'translateX(' + (-direction * 12) + 'px)' }
          ], timing),
          targetPanel.animate([
            { opacity: 0, transform: 'translateX(' + (direction * 12) + 'px)' },
            { opacity: 1, transform: 'translateX(0)' }
          ], timing)
        ];

        Promise.all(this._tabAnimations.map(function (animation) { return animation.finished; }))
          .catch(function () {})
          .then(() => {
            if (transitionId !== this._tabTransitionId) return;
            this.settleTabPanels(targetPanel);
            this._tabAnimations.forEach(function (animation) { animation.cancel(); });
            this._tabAnimations = [];
          });
      }

      settleTabPanels(targetPanel, options) {
        this.querySelectorAll('[data-discovery-panel]').forEach(function (panel) {
          var active = panel === targetPanel;
          panel.hidden = !active;
          panel.toggleAttribute('inert', !active);
          panel.classList.remove('is-leaving', 'is-entering');
        });
        this._activePanel = targetPanel || null;
        if (options && options.resetScroll && targetPanel) targetPanel.scrollTop = 0;
      }

      cancelTabTransition() {
        if (!this._tabAnimations || !this._tabAnimations.length) return;
        this._tabTransitionId += 1;
        var animations = this._tabAnimations;
        this._tabAnimations = [];
        this.settleTabPanels(this._activePanel);
        animations.forEach(function (animation) { animation.cancel(); });
      }

      handleDrawerOpen(event) {
        if (!event.detail || event.detail.drawer === this || this.getAttribute('aria-hidden') !== 'false') return;
        this.close({ handoff: true, keepOverlay: true });
      }

      handleClick(event) {
        if (event.target.closest('[data-discovery-drawer-close]')) {
          this.close();
          return;
        }

        var tab = event.target.closest('[data-discovery-tab]');
        if (tab) {
          this.switchTab(tab.dataset.discoveryTab, false);
          return;
        }

        var copyButton = event.target.closest('[data-discovery-copy]');
        if (copyButton) {
          var block = copyButton.closest('[data-discovery-block]');
          var value = block && block.querySelector('[data-discovery-promo-value]');
          var status = block && block.querySelector('[data-discovery-copy-status]');
          var copyFailedLabel = this.dataset.copyFailedLabel || 'Copy failed';
          if (!value) return;
          copyText(value.textContent.trim()).then(function () {
            copyButton.textContent = copyButton.dataset.copiedLabel || 'Copied';
            if (status) status.textContent = copyButton.dataset.copiedLabel || 'Copied';
            window.setTimeout(function () { copyButton.textContent = copyButton.dataset.copyLabel || 'Copy'; }, 1800);
          }).catch(function () {
            if (status) status.textContent = copyFailedLabel;
          });
          return;
        }

        var quickView = event.target.closest('[data-quick-view]');
        if (quickView) {
          return;
        }

        var addButton = event.target.closest('[data-discovery-add-to-cart]');
        if (!addButton || addButton.disabled) return;
        var variantId = addButton.dataset.variantId;
        if (!variantId || !window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.addLines !== 'function') return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        if (window.AxiomAddToCartAnimation) {
          window.AxiomAddToCartAnimation.play({ button: addButton, imageUrl: addButton.dataset.imageUrl || '', mode: 'quick' });
        }
        window.AxiomStandardStorefront.addLines({ id: variantId, quantity: 1 }, {
          target: addButton,
          source: 'discovery-drawer',
          detail: { keepSourceDrawerOpen: true }
        }).catch(function () {}).finally(function () {
          addButton.disabled = false;
          addButton.removeAttribute('aria-busy');
        });
      }

      handleKeydown(event) {
        var activeTab = event.target.closest('[data-discovery-tab]');
        if (!activeTab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        var tabs = Array.from(this.querySelectorAll('[data-discovery-tab]'));
        var index = tabs.indexOf(activeTab);
        if (index < 0) return;
        event.preventDefault();
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.switchTab(tabs[index].dataset.discoveryTab, true);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    var drawer = getActiveDrawer();
    if (drawer && typeof drawer.open === 'function') drawer.open(trigger);
  });

  document.addEventListener('click', function (event) {
    var overlay = getOverlay();
    if (!overlay || event.target !== overlay || !overlay.classList.contains('overlay--discovery-active')) return;
    var drawer = getActiveDrawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  document.addEventListener('shopify:section:load', function () {
    syncTriggers(getActiveDrawer());
  });

  // Theme editor: the drawer opens while its section or one of its blocks is selected, on the tab
  // of that block, and closes when the merchant moves on (theme-editor.js).
  if (window.Axiom && window.Axiom.editor) {
    window.Axiom.editor.register('discovery-drawer', {
      section: 'discovery-drawer',
      open: function (drawer, event) {
        if (drawer.getAttribute('aria-hidden') !== 'false') drawer.open(null, { preview: true });
        var block = event.target.closest('[data-discovery-block]');
        if (!block || !drawer.contains(block)) return;
        drawer.switchTab(block.dataset.discoveryGroup || 'tab_1', false);
        window.requestAnimationFrame(function () { block.scrollIntoView({ block: 'center', behavior: 'smooth' }); });
      },
      close: function () {
        document.querySelectorAll('discovery-drawer[aria-hidden="false"]').forEach(function (drawer) {
          drawer.close();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncTriggers(getActiveDrawer()); });
  } else {
    syncTriggers(getActiveDrawer());
  }

  window.AxiomDiscoveryDrawerController = {
    sync: function () { syncTriggers(getActiveDrawer()); }
  };
})();
